import {
  MAGENTO_CART_URL,
  hasMagento,
  queryCart as magentoQueryCart,
  queryProductsDetails as magentoQueryProductsDetails,
  addProductToCart as magentoAddProductToCart,
  addProductToCartWashpass as magentoAddProductToCartWashpass,
  createCart as magentoCreateCart,
  requestUserCart as magentoRequestUserCart,
} from "./magento";
import {
  hasShopify,
  queryCart as shopifyQueryCart,
  queryProductsDetails as shopifyQueryProductsDetails,
  getCartUrl as shopifyGetCartUrl,
  addProductToCart as shopifyAddProductToCart,
  createCart as shopifyCreateCart,
} from "./shopify";
import {
  hasCommerceCloud,
  queryProductsDetails as ccQueryProductsDetails,
  getCartUrl as ccGetCartUrl,
  createBasket,
  getBasket,
  addProductToBasket,
  requestUserBasket,
} from "./commerce-cloud";

export const hasEcommerce = !!hasMagento || !!hasShopify || !!hasCommerceCloud;
export const getProvider = () => {
  if (hasShopify) {
    return "ecommerce";
  } else if (hasCommerceCloud) {
    return "ecommerce";
  } else if (hasMagento) {
    return "magento";
  }
  return null;
};

export const getCartUrl = async (cartId, userLogged) => {
  if (hasShopify) {
    return shopifyGetCartUrl(cartId);
  } else if (hasCommerceCloud) {
    return ccGetCartUrl(cartId);
  } else if (hasMagento) {
    return userLogged ? MAGENTO_CART_URL : `${MAGENTO_CART_URL}?cartId=${cartId}`;
  }
  return null;
};

export const createCart = async () => {
  if (hasShopify) {
    return shopifyCreateCart();
  } else if (hasCommerceCloud) {
    return createBasket();
  } else if (hasMagento) {
    return magentoCreateCart();
  }
  return null;
};

export const queryCart = async (cartId) => {
  if (hasShopify) {
    return shopifyQueryCart(cartId);
  } else if (hasCommerceCloud) {
    return getBasket(cartId);
  } else if (hasMagento) {
    return magentoQueryCart(cartId);
  }
  return null;
};

export const queryProductsDetails = async (productIds, currency) => {
  if (hasShopify) {
    return shopifyQueryProductsDetails(productIds);
  } else if (hasCommerceCloud) {
    return ccQueryProductsDetails(productIds, currency);
  } else if (hasMagento) {
    return magentoQueryProductsDetails(productIds);
  }
  return [];
};

export const addProductToCart = async (productId, cartId, userLogged, quantity) => {
  if (hasShopify) {
    return shopifyAddProductToCart(productId, cartId, quantity);
  } else if (hasCommerceCloud) {
    return addProductToBasket(productId, cartId, quantity);
  } else if (hasMagento) {
    return magentoAddProductToCart(productId, cartId, userLogged);
  } else {
    return null;
  }
};

export const requestUserCart = async (userData, guestCartId) => {
  if (hasShopify) {
    return shopifyQueryCart(guestCartId);
  } else if (hasCommerceCloud) {
    return requestUserBasket(userData, guestCartId);
  } else if (hasMagento) {
    return magentoRequestUserCart(userData, guestCartId);
  } else {
    return null;
  }
};

export const addProductToCartWashpass = async (productId, cartId, selected_options, userLogged) => {
  if (hasMagento) {
    return magentoAddProductToCartWashpass(productId, cartId, selected_options, userLogged);
  } else if (hasShopify) {
    return null;
  } else {
    return null;
  }
};
